import React from 'react';

import { EditableText } from 'components/EditableText';

const EditableTextField = ({ field, helpers, haveError, ...restProps }) => {
  return <EditableText {...restProps} {...field} />;
};

export default React.memo(EditableTextField);
